
export const getGridPreviewCarouselStyle = () => ({
  gridPreviewContainer: {
    '& .ms-Panel-main': {
      width: '90%',
      '@media screen and (min-width: 1377px)': {
        width: 1377,
      },
    },
    '& .placements-grid-preview-cell': {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      '& .preview-header': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',

        '& .ad-preview-title.with-additional-tag': {
          marginRight: 8,
          display: 'inline-block',
          flexGrow: 0,
        },

        '& .flex-grow': {
          flexGrow: 1,
        },

        '& .ad-preview-actions.inline-title': {
          display: 'inline-block',
          flexGrow: 0,
          '& > button': {
            marginRight: 8,
          },
        },
      },
    },
  },
});

export const getAdPlacementStyle = () => ({
  cellRoot: {
    height: '100%',
    maxHeight: 482,
  },
  placementRoot: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    maxHeight: 422,
    '& .ad-placement-preview': {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      '& .new-responsive-ad-preview-container': {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '& .card-parent': {
          display: 'flex',
          flexGrow: 1,
          flexDirection: 'column',
          '& .ad-placement-card-preview': {
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column',
          },
        },
        '& a.responsive-ad-preview-content': {
          display: 'block',
          position: 'relative',
          boxSizing: 'content-box',
          overflow: 'hidden',
          boxShadow: '0px 0.511px 1.533px rgb(0 0 0 / 10%), 0px 2.72533px 6.132px rgb(0 0 0 / 13%)',
          borderRadius: 5.11,
          background: '#fff',
          margin: 'auto',
          top: 0,
        },
        '& .additional-disclaimer-message': {
          position: 'static',
          textAlign: 'center',
        },
        '& .preview-string': {
          position: 'static',
        },
      },
    },
    '& .action-label': {
      textAlign: 'center',
      fontSize: 16,
      lineHeight: 2,
    },
  },
});
